module.exports = __webpack_public_path__ + "media/images/games/fifa-21/rectangle-efd7110763b188a28be4a175f52f2a7a.jpg";